import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { ACCENT, ACCENT_SOFT } from "./assessmentTheme";

// Shared empty state for Assessment tables: icon, the screen's own message, and an optional hint.
function AssessmentEmptyState({ message, hint }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, py: 3 }}>
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: ACCENT_SOFT,
          color: ACCENT,
        }}
      >
        <InboxOutlinedIcon sx={{ fontSize: 28 }} />
      </Box>
      <Typography sx={{ fontWeight: 700, color: "#344054" }}>{message}</Typography>
      {hint && (
        <Typography variant="body2" color="text.secondary">
          {hint}
        </Typography>
      )}
    </Box>
  );
}

AssessmentEmptyState.propTypes = {
  message: PropTypes.string.isRequired,
  hint: PropTypes.string,
};

export default AssessmentEmptyState;
